import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import 'rsuite/dist/rsuite.min.css';
import { calendarClock } from 'whealth-core-web/assets/images';
import './QueueView.scss';
import { useGetLoginUserDataQuery } from 'redux/apiSlice';
import useApiManager from 'networking/ApiManager';
import { timeFormat, dateFormatStringSingleDate } from '../whealth-core-web/components/Helper';
import { useNavigate, Link } from 'react-router-dom';
import { Button, Modal, DatePicker } from 'rsuite';
import { ToastContainer, toast } from 'react-toastify';
import { CommonAlert, Pagination, Select2DropDown, Loader, CoreButton, FilterChips, CoreInputBox } from 'whealth-core-web/components';
import { NotebookPen, Trash2 } from 'lucide-react';

export default function IpdUserView() {
  const { id } = useParams();
  const ApiClient = useApiManager();
  const navigate = useNavigate();
  let userData = useGetLoginUserDataQuery()?.data?.data || {};
  const [modeData] = useState([
    { key: 'in-person', value: 'In-Person' },
    { key: 'virtual', value: 'Virtual' },
  ]);
  const preFormData = { session_date: '', doctor: '', modality: '', bed: '', pt_code: '', price: '', ipd_user: '' };
  const value = useRef('');
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [countData, setCountData] = useState(0);
  const [startCount, setStartCount] = useState(0);
  const [open, setOpen] = useState(false);
  const [isEditSession, setIsEditSession] = useState(false);
  const [searchStr, setSearchStr] = useState('');
  const [userDoctor, setUserDoctor] = useState([]);
  const [permissions, setPermissions] = useState({});
  const [formData, setFormData] = useState({ ...preFormData });
  const [isDeleteSession, setIsDeleteSession] = useState(false);
  const [gender, setGender] = useState([
    { value: 'Male', label: 'Male' },
    { value: 'Female', label: 'Female' },
    { value: 'Other', label: 'Other' },
  ]);
  const [errMsg, setErrMsg] = useState('');
  const [backErrMsg, setBackErrMsg] = useState({});
  const [sessionData, setSessionData] = useState([]);

  useEffect(() => {
    if (userData?.id) {
      console.log(id);
      getIpdSessions();
      setFormData((prevFormData) => ({
        ...prevFormData,
        ['ipd_user']: id,
      }));
    }
  }, [userData, id, currentPage]);

  const getIpdSessions = () => {
    const today = new Date();
    // Convert to IST by adding 5 hours and 30 minutes
    const istDate = new Date(today.getTime());
    const formattedDate = dateFormatStringSingleDate(istDate);

    let paramsApp = `${id}?user_id=${userData?.id}`;
    ApiClient.getIpduser(paramsApp)
      .then((res) => {
        console.log('getipduser data: ', res?.data);
        setData(res?.data);
        // setTotalPages(res?.data?.total_pages)
        // setCountData(res?.data?.count)
        // let startPage = res?.data?.page_size*currentPage - res?.data?.page_size
        // setStartCount(startPage)
        // setUserLocation(res?.data?.location_list)
      })
      .catch((err) => {
        console.log('getipduser error: ', err);
      });

    let sessionparam = `?ipd_user=${id}&user_id=${userData?.id}&page=${currentPage}`;
    ApiClient.getIpdSession(sessionparam)
      .then((res) => {
        console.log('getIpdSession data: ', res?.data?.doctors);
        setSessionData(res?.data?.results);
        setTotalPages(res?.data?.total_pages);
        setCountData(res?.data?.count);
        setPermissions(res?.data?.permissions);
        let startPage = res?.data?.page_size * currentPage - res?.data?.page_size;
        setStartCount(startPage);
        setUserDoctor(res?.data?.doctors);
      })
      .catch((err) => {
        console.log('getipduser error: ', err);
      });
  };

  const handleChange = (name, data) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: data,
    }));
  };

  const handleCancelClick = () => {
    setOpen(false);
    setTimeout(() => {
      setFormData({ ...preFormData });
      setIsEditSession(false);
      setIsDeleteSession(false);
    }, 200);
  };

  function formatDate(dateString) {
    // Parse the input date string as a UTC time
    const utcDate = new Date(dateString);

    // Convert UTC time to IST
    const istOffset = 5 * 60 + 30; // IST is UTC+5:30 in minutes
    const istTime = new Date(utcDate.getTime() + istOffset * 60 * 1000);

    // Extract date components in IST
    const day = String(istTime.getUTCDate()).padStart(2, '0');
    const month = String(istTime.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = istTime.getUTCFullYear();

    // Extract time components in IST
    let hours = istTime.getUTCHours();
    const minutes = String(istTime.getUTCMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; // Convert to 12-hour format

    // Format and return the result
    return `${day}-${month}-${year}, ${hours}:${minutes} ${ampm}`;
  }

  const renderHeader = () => {
    return (
      <>
        <div className='col-md-4'>
          <Link className='userName' to={`/ipd`}>
            <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' style={{ width: '15px' }}>
              <path d='M205 34.8c11.5 5.1 19 16.6 19 29.2l0 64 112 0c97.2 0 176 78.8 176 176c0 113.3-81.5 163.9-100.2 174.1c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-7.5 4.3-14.4 9.8-19.5c9.4-8.8 22.2-26.4 22.2-56.7c0-53-43-96-96-96l-96 0 0 64c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4z' />
            </svg>
          </Link>{' '}
          User View
        </div>
      </>
    );
  };

  const goToPatientProfile = (patientId) => {
    navigate(`/patient/${patientId}/dashboard`);
  };

  const showDetails = () => (
    <>
      <div className='teamHeader stickyHeader'>
        <div className='headerFilesRow'>{renderHeader()}</div>

        <div className='row'>
          <div className='col-md-12'>
            <div className='card'>
              <div className='card-body'>
                <div className='card-title pt-1 pb-2'>
                  <strong>
                    {data?.patient_code} - {data?.patient_name}
                  </strong>
                  <span style={{ float: 'right' }}>
                    {' '}
                    <small>Created At : {formatDate(data?.created_at)}</small>
                  </span>
                </div>
                <div className='row'>
                  <div className='col-md-4'>Age : {data?.age}</div>
                  <div className='col-md-4'>Gender : {data?.gender}</div>
                  <div className='col-md-4'>Mobile No : {data?.mobile_no}</div>
                  <div className='col-md-4 mt-2'>MR No. : {data?.mr_no}</div>
                  <div className='col-md-4 mt-2'>Clinic : {data?.location?.name}</div>
                  <div className='col-md-4 mt-2'>Source : {data?.source}</div>
                </div>
              </div>
            </div>
            <div className='card mt-2'>
              <div className='card-body'>
                <h5 className='card-title pt-1 pb-2'>
                  Session Details
                  <span style={{ float: 'right' }}>
                    {!userData?.read_only && (
                    <Button
                      className='m-0 reusableBtn reusableBtnActive'
                      onClick={() => {
                        setOpen(true);
                      }}
                      style={{ fontSize: '9px' }}
                    >
                      Add Session
                    </Button>
                    )}
                  </span>
                </h5>

                <table className='table table-bordered table-hover'>
                  <thead>
                    <tr className='table-theme'>
                      <th className='table-theme'>Sno</th>
                      <th className='table-theme'>Session Date</th>
                      <th className='table-theme'>Modality</th>
                      <th className='table-theme'>Bed</th>
                      <th className='table-theme'>Price</th>
                      <th className='table-theme'>Physiotherapist </th>
                      <th className='table-theme'>Created By</th>
                      <th className='table-theme'>Created At</th>
                      {!userData?.read_only && (permissions?.edit || permissions?.delete) && <th className='table-theme'>Action</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {sessionData.map((item, index) => (
                      <tr key={index}>
                        <td className='align-content-center'>{startCount + index + 1}</td>
                        <td className='align-content-center'>{item.session_date}</td>
                        <td className='align-content-center'>{item.modality}</td>
                        <td className='align-content-center'>{item.bed}</td>
                        <td className='align-content-center'>{item.price}</td>
                        <td className='align-content-center'>{item?.doctor_details?.full_name}</td>
                        <td className='align-content-center'>{item?.admin_user_details?.full_name}</td>
                        <td className='align-content-center'>{formatDate(item?.created_at)}</td>
                        {!userData?.read_only && (permissions?.edit || permissions?.delete) && (
                          <td className='align-content-center d-flex justify-content-center gap-1'>
                            {permissions?.edit && (
                              <a
                                onClick={() => {
                                  setIsEditSession(true);
                                  setFormData({ ...item });
                                  setOpen(true);
                                }}
                                className='text-decoration-none'
                                style={{ color: '#133696', cursor: 'pointer' }}
                              >
                                <NotebookPen style={{ width: '16px' }} />
                              </a>
                            )}
                            {permissions?.delete && (
                              <a
                                onClick={() => {
                                  setIsDeleteSession(true);
                                  setFormData({ ...item });
                                  setOpen(true);
                                }}
                                className='text-decoration-none'
                                style={{ color: '#133696', cursor: 'pointer' }}
                              >
                                <Trash2 style={{ width: '16px' }} />
                              </a>
                            )}
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className='usersList wrapperContent'>
                  <div className='d-flex justify-content-end mb-4'>
                    <Pagination
                      data={sessionData}
                      length={countData}
                      totalPages={totalPages}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      page='patient'
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal backdrop='static' keyboard={false} open={open} onClose={handleCancelClick}>
        <Modal.Header>
          <Modal.Title>{isEditSession ? 'Update Session' : isDeleteSession ? 'Delete Session' : 'Add Session'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
            <div className='col-md-6'>
              <div>
                <label class='inputlabel'>
                  <span className='requiredInput'> * </span>Session Date
                </label>
              </div>
              <DatePicker
                className='w-100'
                container={() => document.getElementById('patientDatePickerContainer')}
                placeholder='Session Date'
                format='yyyy-MM-dd'
                onClean={() => handleChange('session_date', null)}
                // disabledDate={(date) => {
                //   if (new Date(date) < new Date().setHours(0, 0, 0)) {
                //     return true;
                //   } else {
                //     return false;
                //   }
                // }}
                disabled={isDeleteSession}
                value={formData.session_date ? new Date(formData.session_date) : null}
                onSelect={(data) => {
                  // handleChange('session_date',data)
                  const formattedDate = data.toISOString().split('T')[0]; // Extract 'yyyy-MM-dd'
                  handleChange('session_date', formattedDate);
                }}
              />
            </div>
            <div className='col-md-6'>
              <Select2DropDown
                value={formData.doctor}
                data={userDoctor}
                label={`Physiotherapist`}
                placeholder={`Physiotherapist`}
                valueKey='value'
                labelKey='label'
                retuired={true}
                onSelect={(selectedValue, dataObj) => {
                  console.log(selectedValue);
                  handleChange('doctor', selectedValue);
                }}
                disabled={isDeleteSession}
              />
            </div>
            <div className='col-md-6 mt-2'>
              <CoreInputBox
                type={`text`}
                retuired={false}
                label={'PT Code'}
                labelStyle={{ fontWeight: 'var(--lightFont)' }}
                setValue={(data) => handleChange('pt_code', data)}
                value={formData.pt_code}
                disabled={isDeleteSession}
              />
            </div>

            <div className='col-md-6 mt-2'>
              <CoreInputBox
                type={`text`}
                retuired={true}
                label={'Modality'}
                // maxLength={3}
                // validateMax= {150}
                // validateNumbers= {true}
                labelStyle={{ fontWeight: 'var(--lightFont)' }}
                setValue={(data) => handleChange('modality', data)}
                value={formData.modality}
                disabled={isDeleteSession}
              />
            </div>

            <div className='col-md-6 mt-2'>
              <CoreInputBox
                type={`text`}
                retuired={false}
                label={'Bed'}
                labelStyle={{ fontWeight: 'var(--lightFont)' }}
                setValue={(data) => handleChange('bed', data)}
                value={formData.bed}
                disabled={isDeleteSession}
              />
            </div>

            <div className='col-md-6 mt-2'>
              <CoreInputBox
                type={`text`}
                retuired={false}
                label={'Price'}
                maxLength={7}
                validateNumbers={true}
                labelStyle={{ fontWeight: 'var(--lightFont)' }}
                setValue={(data) => handleChange('price', data)}
                value={formData.price}
                disabled={isDeleteSession}
              />
            </div>
          </div>

          <div className='row mt-2'>
            <div className='col-md-12'>
              <span style={{ color: 'red' }}>
                {errMsg}
                <br />
                {backErrMsg?.mr_no}
              </span>
              <CoreButton
                customStyle={isDeleteSession ? { backgroundColor: 'white', border: '1px solid red' } : {}}
                onClick={() => {
                  console.log(formData);
                  setErrMsg('');
                  setBackErrMsg({});
                  if (isDeleteSession) {
                    ApiClient.deleteIpdSessions(formData)
                      .then((res) => {
                        if (res?.data?.success) {
                          setOpen(false);
                          toast.success('Session deleted successfully!');
                          getIpdSessions();
                          setFormData((prevData) => ({
                            ...preFormData,
                            ipd_user: prevData.ipd_user,
                          }));
                        } else {
                          let message = res?.data?.message;
                          toast.error(message);
                        }
                      })
                      .catch((err) => {
                        handleCancelClick();
                        let response = err?.response?.data;
                        let message = response?.detail || response?.message;
                        setIsDeleteSession(false);
                        toast.error(message);
                      });
                    setIsDeleteSession(false);
                    return;
                  }
                  if (formData?.session_date == '' || formData?.doctor == null || formData?.doctor == '' || formData?.modality == '') {
                    setErrMsg('Please fill all mandatory fields');
                  } else if (isEditSession) {
                    ApiClient.updateIpdSessions(formData)
                      .then((res) => {
                        if (res?.data?.success) {
                          setOpen(false);
                          toast.success('Session updated successfully!');
                          getIpdSessions();
                          setFormData((prevData) => ({
                            ...preFormData,
                            ipd_user: prevData.ipd_user,
                          }));
                        } else {
                          let message = res?.data?.message;
                          toast.error(message);
                        }
                      })
                      .catch((err) => {
                        handleCancelClick();
                        let response = err?.response?.data;
                        let message = response?.detail || response?.message;
                        setIsEditSession(false);
                        toast.error(message);
                      });
                    setIsEditSession(false);
                  } else {
                    ApiClient.saveIpdSessions(formData)
                      .then((res) => {
                        if (res?.data?.id) {
                          setOpen(false);
                          toast.success('Saved!');
                          getIpdSessions();
                          setFormData((prevData) => ({
                            session_date: '',
                            doctor: '',
                            modality: '',
                            bed: '',
                            pt_code: '',
                            price: '',
                            ipd_user: prevData.ipd_user,
                          }));
                        } else {
                          toast.error('Something went wrong');
                        }
                      })
                      .catch((err) => {
                        setBackErrMsg(err?.response?.data);
                      });
                  }
                }}
                customClass={`btn btn-secondary btn-lg ${isDeleteSession ? 'impt-red-color' : ''}`}
                title={isEditSession ? 'Update Details' : isDeleteSession ? 'Delete Details' : 'Save Details'}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );

  return (
    <div className='wrapper'>
      {showDetails()}
      <ToastContainer />
    </div>
  );
}

// export default ipdUserView;
